import { Model } from "pinia-orm";

export default class CompetenceDomain extends Model {
  static entity = "competenceDomains";
  static primaryKey = ["competenceUuid", "domainUuid"];

  static fields() {
    return {
      competenceUuid: this.uid(""),
      domainUuid: this.uid(""),
    };
  }
}
